module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"noResults":"No results"},"de":{"noResults":"Keine Ergebnisse"},"fr":{"noResults":"Aucun résultat"},"it":{"noResults":"Nessun Risultato"}}')
  delete Component.options._Ctor
}
